function waitUntil(conditionFn, callback, interval = 50, timeout = 3000) {
  const start = Date.now();
  const timer = setInterval(() => {
    if (conditionFn()) {
      clearInterval(timer);
      callback();
    } else if (Date.now() - start > timeout) {
      clearInterval(timer);
      console.warn('[ShopifyAnalytics] Timed out waiting for lib.user()');
      callback();
    }
  }, interval);
}

function formatFiltersViewedData(rawFilters) {
  const formatted = [];

  for (const attribute in rawFilters) {
    const values = rawFilters[attribute];
    if (typeof values === 'object' && values !== null) {
      for (const value in values) {
        formatted.push(`${attribute}:${value}`);
      }
    }
  }

  return formatted;
}

function chunkArray(arr, size) {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
}

function extractFiltersFromReferrer() {
  try {
    const ref = new URL(document.referrer);
    const rawFilters = ref.searchParams.get('filters');
    if (!rawFilters) return [];

    const decoded = decodeURIComponent(decodeURIComponent(rawFilters));
    const parts = decoded.split(/\s+AND\s+/);
    return parts.map(filter => filter.replace(/^\(+|\)+$/g, '').trim());
  } catch (e) {
    console.warn('[Analytics] Failed to extract filters from referrer:', e);
    return [];
  }
}

(() => {
  const defaultIndex = 'shopify_products';
  waitUntil(() =>
    typeof ShopifyAnalytics !== 'undefined' &&
    typeof ShopifyAnalytics.lib?.user === 'function',
    () => {
      const userTraits = ShopifyAnalytics.meta.page.customerId
        ? {
            userToken: "",
            authenticatedUserToken: ShopifyAnalytics.meta.page.customerId.toString()
          }
        : {
            userToken: ShopifyAnalytics.lib.user()?.traits()?.uniqToken?.toString() || "",
            authenticatedUserToken: ""
          };

      Shopify.analytics.publish('setUserToken', {
        userToken: userTraits.userToken,
        authenticatedUserToken: userTraits.authenticatedUserToken,
      });

      Shopify.analytics.publish("setData", {
        queryID: null,
        index: defaultIndex
      });

      const refFilters = extractFiltersFromReferrer();
      if (refFilters.length) {
        Shopify.analytics.publish('algolia:referrerFilters', {
          filters: refFilters,
          timestamp: Date.now()
        });
      }
    }
  );
})();

window.addEventListener('algolia:setData', (e) => {
  const { queryID, index } = e.detail;
  if (queryID) {
    Shopify.analytics.publish("setData", {
      queryID,
      index
    });
  }
});

window.addEventListener('algolia:productsViewed', (e) => {
  const products = e.detail.products || [];
  const objectIDs = products.map(product => product.objectID).filter(Boolean);

  const chunks = chunkArray(objectIDs, 20);

  for (const chunk of chunks) {
    Shopify.analytics.publish("viewedObjectIDs", {
      objectIDs: chunk
    });
  }
});

window.addEventListener('algolia:filtersViewed', (e) => {
  const rawFilters = e.detail.filters;
  const filters = formatFiltersViewedData(rawFilters);
  const chunks = chunkArray(filters, 10);

  for (const chunk of chunks) {
    Shopify.analytics.publish('viewedFilters', {
      filters: chunk,
    });
  }
});

document.addEventListener('click', e => {
  const defaultIndex = 'shopify_products';

  const productEl = e.target.closest('[data-position][data-object-id]') ||
                    e.target.closest('[data-object-id]') ||
                    e.target.closest('a[href*="variant="]');

  if (productEl) {
    const dataset = productEl.dataset;
    const objectId = dataset.objectId || new URLSearchParams(productEl.href?.split('?')[1]).get('variant');
    const position = dataset.position;

    if (objectId && position) {
      Shopify.analytics.publish("clickedAfterSearch", {
        objectIDs: [objectId],
        positions: [Number(position)],
      });
    } else if (objectId) {
      Shopify.analytics.publish("clickedNotAfterSearch", {
        index: defaultIndex,
        objectIDs: [objectId],
      });
    }
  }

  if (e.target.closest('[data-filter]')) {
    const { filter } = e.target.closest('[data-filter]').dataset;
    Shopify.analytics.publish("clickedFilter", {
      filters: [filter]
    });
  }
});